<div class="pt-6">
  <div class="p-2 ">
    <h3 [ngClass]="'text-'+globals.colorTheme">
      <i class=" material-icons">shopping_basket</i>
      Quantities</h3>
  </div>
  <mat-accordion class="example-headers-align">
    <mat-expansion-panel formcontrolname [expanded]="step === 0" (opened)="setStep(0)" hideToggle="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Item
        </mat-panel-title>
        <mat-panel-description>
          <small> Search Item </small>
        </mat-panel-description>
        <span>
          <i class="fas fa-shopping-basket fa-2x"></i>
        </span>
      </mat-expansion-panel-header>

      <app-item-search [itemSearchType]="ItemSearchType" [forSalesOrder]="false" (sendResponseEventEmitter)="receiveItems($event)"></app-item-search>

    </mat-expansion-panel>
    <mat-expansion-panel hideToggle="true" [expanded]="step === 1" (opened)="setStep(1)" *ngIf="itemsDetails">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Items
        </mat-panel-title>
        <mat-panel-description>
          <small>Search Results</small>
        </mat-panel-description>
        <span>
          <i class="fas fa-boxes fa-2x"></i>
        </span>
      </mat-expansion-panel-header>
      <app-item-list  [forSalesOrder]="false"[itemsDetailList]="itemsDetails" [showLocationDetails]="true" [isLocationSelectable]="true" [itemSearchType]="ItemSearchType"></app-item-list>
    </mat-expansion-panel>
  </mat-accordion>
</div>